<template>
	<div>
		<b-card-header header-tag="header" class="p-1 info-item-header" role="tab">
	    <b-btn block href="#" v-b-toggle="feature.id" variant="secondary" @mouseover="highlightFeature(true)" @mouseout="highlightFeature(false)">{{title}}</b-btn>
	  </b-card-header>
	  <b-collapse :id="feature.id" :visible="!index" accordion="my-accordion" role="tabpanel">
	    <b-card-body>
	      <b-table small thead-class="hidden_header" :items="items">
	      	<template slot="fieldname" slot-scope="data"><span class="bold-cap">{{data.value}}</span></template>
	      	<span slot="value" slot-scope="data" v-html="data.value"></span>
	      </b-table>
	    </b-card-body>
	  </b-collapse>
	</div>
</template>

<script>
export default {

  name: 'info-item',
  props: {
  	feature:{
  		type:Object,
  		required: true
  	},
  	index:{
  		type:Number,
  		required:true
  	}
  },
  methods: {
  	highlightFeature(highlight){
  		this.$emit("highlight-feature",{"feature":this.feature,"highlight":highlight})
  	}
  },
  data () {
    return {
    	title:"",
    	items:[]
    }
  },
  mounted () {
  	var vm = this
  	var thisItem = {}
  	var layer = [{"fieldname":"layer","value":this.feature.layer}]
  	var itemlist = this.feature.infoSettings["fields"].map((field)=>{
  		let thisItem = {}
  		if(field == "url"){
  			if(vm.feature.properties[field]!=null){
	  			thisItem["fieldname"] = "More Info"
	  			thisItem["value"] = '<a href="'+vm.feature.properties[field]+'" target="_blank" class="btn btn-sm btn-info">Go</a>'
  			}
  		} else {
  			thisItem["fieldname"] = field
  			thisItem["value"] = vm.feature.properties[field]
  		}
  		return thisItem
  	})
  	this.items = layer.concat(itemlist)
  	this.title = this.feature.properties[this.feature.infoSettings["title"]]
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Info/InfoItem.vue